var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9502 36.592L96.9702 36.9831L102.205 101.723",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0081 12.3143L87.2732 7.6814L76.4731 8.50369",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.06 92.6883L103.258 19.8553",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3807 108.021L18.5918 21.1088L26.5239 20.4871L75.4803 16.6765H75.4904L76.0319 16.6263",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1742 50.5408C48.3133 52.3356 47.9173 54.1314 47.0361 55.7012C46.155 57.2711 44.8283 58.5445 43.2237 59.3605C41.6191 60.1766 39.8086 60.4987 38.0209 60.2861C36.2333 60.0735 34.5488 59.3358 33.1803 58.1662C31.8118 56.9966 30.8207 55.4476 30.3323 53.7149C29.8438 51.9823 29.88 50.1437 30.4361 48.4315C30.9922 46.7194 32.0434 45.2105 33.4568 44.0956C34.8702 42.9806 36.5824 42.3097 38.3769 42.1675",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0399 51.3632L43.1101 51.4133L40.3123 54.6924L33.4633 48.8361L36.2611 45.557L39.7708 48.5553L47.6127 39.3798L50.8818 42.1876L43.0399 51.3632Z",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9626 76.6536L44.0227 76.7138L41.2249 79.9829L34.3759 74.1266L37.1737 70.8474L40.6834 73.8458L48.5253 64.6802L51.8044 67.478L43.9626 76.6536Z",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8462 75.9015C48.9855 77.6968 48.5894 79.4931 47.7079 81.0632C46.8264 82.6334 45.4992 83.907 43.894 84.7229C42.2888 85.5388 40.4777 85.8605 38.6897 85.6472C36.9017 85.4339 35.2171 84.6953 33.8488 83.5247C32.4806 82.3541 31.4901 80.8041 31.0027 79.0707C30.5152 77.3373 30.5527 75.4982 31.1104 73.7861C31.668 72.0739 32.7208 70.5656 34.1356 69.4517C35.5504 68.3378 37.2637 67.6684 39.0589 67.5282",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4186 21.1991L93.0594 34.9273L79.4514 35.9903L78.4486 21.1991M76.0921 16.2453L77.6264 38.1463L97.7424 36.5819L76.062 16.2453H76.0921Z",
    fill: "#52C5D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7893 111.721C47.5356 111.721 51.3832 107.874 51.3832 103.127C51.3832 98.3811 47.5356 94.5334 42.7893 94.5334C38.043 94.5334 34.1953 98.3811 34.1953 103.127C34.1953 107.874 38.043 111.721 42.7893 111.721Z",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9977 51.1827C55.4646 48.5353 59.5459 48.2645 63.146 48.6957C66.746 49.1269 70.4062 50.0696 73.916 49.1871C76.6536 48.4952 79.0503 46.7403 81.808 46.1787C85.1874 45.4266 88.6771 46.4595 91.9863 47.4824",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0807 76.9645C56.5476 74.3171 60.6289 74.0463 64.229 74.4775C67.829 74.9087 71.4892 75.8514 74.999 74.9689C77.7366 74.277 80.1333 72.5221 82.891 71.9605C86.2704 71.2084 89.7601 72.2413 93.0694 73.2642",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0891 103.769C59.566 101.132 63.6474 100.861 67.2474 101.282C70.8475 101.703 74.5076 102.656 78.0174 101.774C80.7551 101.092 83.1517 99.3369 85.9094 98.7653C89.2888 98.0132 92.7786 99.0461 96.0878 100.069",
    stroke: "#52C5D8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.984 61C119.995 74.7666 115.18 88.1015 106.376 98.685C105.116 100.202 103.777 101.651 102.365 103.027C101.513 103.869 100.64 104.672 99.748 105.454C89.0091 114.836 75.2302 120.003 60.9699 119.994C57.8806 119.993 54.7961 119.752 51.7442 119.272C44.7633 118.181 38.039 115.829 31.8989 112.333C24.9224 108.382 18.8244 103.051 13.9773 96.6644C9.13024 90.2779 5.63578 82.9705 3.70736 75.1883C1.77894 67.4062 1.45704 59.3126 2.76128 51.4019C4.06552 43.4911 6.96855 35.9292 11.2931 29.178C15.6176 22.4268 21.2729 16.6279 27.9136 12.1354C34.5542 7.64294 42.0409 4.55121 49.9165 3.04902C57.792 1.54683 65.8911 1.6657 73.7192 3.39838C81.5473 5.13106 88.94 8.44117 95.446 13.1266C96.4488 13.8386 97.4516 14.5806 98.3541 15.3528L98.6349 15.5935C105.305 21.1322 110.674 28.0717 114.361 35.9193C118.047 43.7668 119.96 52.3298 119.964 61H119.984Z",
    stroke: "#52C5D8",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/pm.d8d617a02cb34b92fe504c6353a08844.svg";
export { ForwardRef as ReactComponent };